import numberToPersian from "./NumberToPersian";
import axiosConfig from "./axiosConfig";

const RefereeRows = (props) => {
  let totalRound = "";

  if (props.bluePoint > props.redPoint) {
    totalRound = "bg-primary";
  } else if (props.bluePoint < props.redPoint) {
    totalRound = "bg-danger";
  } else {
    totalRound = "bg-secondary";
  }

  function clickHandle(refereeid, color, action) {
    try {
      axiosConfig
        .get(
          "change-points.php?refereeid=" +
            refereeid +
            "&color=" +
            color +
            "&action=" +
            action
        )
        .then((response) => {
          console.log("response= ", response);
        });
    } catch (error) {
      console.log(error.errors);
    }
  }

  return (
    <tr>
      <td>داور {numberToPersian(props.refereeNo)}</td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() => clickHandle(props.refereeid, "blue", "increase")}
        >
          +
        </span>
        &nbsp; {numberToPersian(props.bluePoint)} &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() => clickHandle(props.refereeid, "blue", "decrease")}
        >
          -
        </span>
      </td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td style={{ fontSize: "15px" }}>
        <span
          className={"badge bg-success points " + props.disableState}
          onClick={() => clickHandle(props.refereeid, "red", "increase")}
        >
          +
        </span>
        &nbsp; {numberToPersian(props.redPoint)}
        &nbsp;
        <span
          className={"badge bg-warning text-black points " + props.disableState}
          onClick={() => clickHandle(props.refereeid, "red", "decrease")}
        >
          -
        </span>
      </td>

      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td className={totalRound}>&nbsp;</td>
    </tr>
  );
};

export default RefereeRows;
